import type { UsePermissionsReturn } from '@/contexts/AuthContext/usePermissions';
import { AUDIT_LOG_SYSTEM_PERMISSION, Permission } from '@/contexts/AuthContext/permissions';

export const CLOUD_AGENT_RUN_AUDIT_SYSTEM_PERMISSION = AUDIT_LOG_SYSTEM_PERMISSION;

export const canViewCloudAgentRunAudit = (
    permissions: Pick<UsePermissionsReturn, 'isOwner' | 'checkPermissions'>
) => (
    permissions.isOwner || permissions.checkPermissions([Permission.AUDIT_LOG_VIEW])
);
